module.exports = __webpack_public_path__ + "img/reschedule.f9213edf.svg";